import React, { createContext, useContext, useRef, useCallback } from 'react';

const AudioPlayerContext = createContext();

export const AudioPlayerProvider = ({ children }) => {
  // Keep track of all registered audio players
  const audioPlayersRef = useRef(new Map());
  const currentlyPlayingRef = useRef(null);

  // Register an audio player
  const registerAudioPlayer = useCallback((id, audioElement) => {
    console.log('[AudioPlayerContext] Registering player:', id);
    audioPlayersRef.current.set(id, audioElement);
    
    // Return cleanup function
    return () => {
      console.log('[AudioPlayerContext] Unregistering player:', id);
      audioPlayersRef.current.delete(id);
      if (currentlyPlayingRef.current === id) {
        currentlyPlayingRef.current = null;
      }
    };
  }, []);

  // Pause all players except the one with the given ID
  const pauseAllExcept = useCallback((playerId) => {
    console.log('[AudioPlayerContext] Pausing all except:', playerId);
    
    audioPlayersRef.current.forEach((audioElement, id) => {
      if (id !== playerId && audioElement && !audioElement.paused) {
        console.log('[AudioPlayerContext] Pausing player:', id);
        audioElement.pause();
      }
    });
    
    currentlyPlayingRef.current = playerId;
  }, []);

  // Notify that a player has stopped
  const notifyPlayerStopped = useCallback((playerId) => {
    if (currentlyPlayingRef.current === playerId) {
      currentlyPlayingRef.current = null;
    }
  }, []);

  const value = {
    registerAudioPlayer,
    pauseAllExcept,
    notifyPlayerStopped,
  };

  return (
    <AudioPlayerContext.Provider value={value}>
      {children}
    </AudioPlayerContext.Provider>
  );
};

export const useAudioPlayer = () => {
  const context = useContext(AudioPlayerContext);
  if (!context) {
    throw new Error('useAudioPlayer must be used within AudioPlayerProvider');
  }
  return context;
};